import { BASIC_QUESTIONS } from './questions.basics.js';
import { ABOUT_QUESTIONS } from './questions.about.js';
import { ADHD_QUESTIONS } from './questions.adhd.js';
import { AUTISM_QUESTIONS } from './questions.autism.js';
import { LEARNING_SUPPORT_QUESTIONS } from './questions.learning.js';
import { STRATEGY_QUESTIONS } from './questions.strategies.js';
import { SCHOOL_DAY_QUESTIONS } from './questions.school.js';
import { TEAM_QUESTIONS } from './questions.team.js';

export const QUESTIONS = [
  ...BASIC_QUESTIONS,
  ...ABOUT_QUESTIONS,
  ...ADHD_QUESTIONS,
  ...AUTISM_QUESTIONS,
  ...LEARNING_SUPPORT_QUESTIONS,
  ...STRATEGY_QUESTIONS,
  ...SCHOOL_DAY_QUESTIONS,
  ...TEAM_QUESTIONS,
];
